import {A360ProductCd, A360ProductModel, Product} from 'Quoting/models/Quoting';

const a360ProductList: Product[] = [
  {
    name: 'Accident',
    code: A360ProductCd.ACC,
    _model: A360ProductModel.ACCMaster,
    _type: 'HEALTH',
  },
  {
    name: 'Critical Illness',
    code: A360ProductCd.CI,
    _model: A360ProductModel.CIMaster,
    _type: 'HEALTH',
  },
  {
    name: 'Hospital Indemnity',
    code: A360ProductCd.HI,
    _model: A360ProductModel.HIMaster,
    _type: 'HEALTH',
  },
];

const GPLU_PRODUCT: Product = {
  name: 'Permanent Life',
  code: A360ProductCd.GPLU,
  _model: A360ProductModel.GPLUMaster,
  _type: 'LIFE',
};

export const productTypeLabel = new Map([
  ['HEALTH', 'Accident and Health'],
  ['LIFE', 'Life and Annuities'],
]);

export const getA360ProductList = (isGPLUEnabled: boolean = false) =>
  isGPLUEnabled ? a360ProductList.concat(GPLU_PRODUCT) : a360ProductList;
